import React from "react"
import { FormattedNumber } from "react-intl"
import { BaseButton, Box, Flex, Stack, Text } from "../../../vanilla"
import { useBasketStore, useGlobalStore, useOrderStore } from "../../../store/hooks/useStore"
import { CheckoutButton } from "./checkout-button"
import { Link } from "../../../components/link"

export const UpdatePaymentAmount = ({ submitOrderProcess }: { submitOrderProcess: () => Promise<void | null> }) => {
  const {
    currency
  } = useGlobalStore()
  const { orderEditOrderTotal, orderTotalWithoutBC, isPaymentRefunding, isPaymentRequired, editMode } = useOrderStore()
  const { bonusCardStatus } = useBasketStore()
  return (
    <>
      {isPaymentRefunding ? (
        <Stack direction="row" padding="16px">
          <Text variant="text6">Amount to refund:</Text>
          <Text color="accent3" variant="text6">
            <FormattedNumber
              value={Math.abs(orderTotalWithoutBC)}
              style="currency"
              currency={currency}
              maximumFractionDigits={2}
              minimumFractionDigits={2}
            />
          </Text>
        </Stack>
      ) : !isPaymentRequired && (
        <Stack direction="row" padding="16px">
          <Text variant="text6">Amount left to pay:</Text>
          <Text color="accent3" variant="text6">
            <FormattedNumber
              style="currency"
              currency={currency}
              value={orderEditOrderTotal}
            />
          </Text>
        </Stack>)}

      <Box
        borderTop="1px"
        borderColor="border1"
        padding={['16px', '16px', '24px']}
      >
        <Flex justifyContent="space-between">
          <BaseButton variant="outlineDark" as={Link} to="/basket">
            <Text variant="unstyled">Back</Text>
          </BaseButton>
          <Stack style={{ width: 230 }}>
            <CheckoutButton
              submitOrderProcess={submitOrderProcess}
              isEditModeEnabled={editMode}
              billingAddressFormValid={true}
              isPaymentRefunding={isPaymentRefunding}
              braintreeFormIsValid={true}
              bonusCardStatus={bonusCardStatus}
              hostedFieldsErrors={false}
              isTopUp={false}
            />
          </Stack>
        </Flex>
      </Box>
    </>
  )
}